<div>
    <ng-container *ngIf="!eventService.loadEventTournaments;else loading">

        <mat-tab-group class="orange-ramadan-tabs">

            <mat-tab label="tab2">
                <ng-template mat-tab-label>
                    البطولات
                    <!--<i class="icon icon-shield"></i>-->
                </ng-template>

                <div class="container">
                    <div class="tournaments-container">
                        <div class="items" *ngFor="let tournament of (eventService.eventTournaments|async)?.data">

                            <div class="items-status" [ngClass]="{'active':tournament.status=='Waiting Players to Join',
                                  'finished':tournament.status=='Finished', 'inprogress':tournament.status=='In Progress'}"></div>
                            <div class="col-sm-6">
                                <a class="tag-container"
                                   [ngStyle]="{'background-image': 'url('+tournament.cover_picture+')'}"
                                   href="https://www.gbarena.com/tournaments/{{tournament.code}}" target="_blank">
                                    <div class="overlay-cover {{gameName}}"></div>

                                    <div class="tag-text tag-3-text">

                                        <div class="text">
                                            <h1>{{tournament.name}}</h1>

                                            <div class="status hidden-lg hidden-md hidden-sm"
                                                 style="display: flex; justify-content: flex-start; align-items: center; direction: ltr;">

                                                <p style="flex-grow: 1; display: flex; flex-flow: column">
                                                <span class="row">
                                                <i class="icon-calendar"></i>
                                                     {{globalService.Date(tournament.start_at)}}
                                                </span>

                                                    <span class="row">
                                                <i class="icon-clock"></i>
                                                 {{globalService.Time(tournament.start_at)}},
                                                 {{tournament.time_zone}}
                                                </span>
                                                </p>

                                                <div class="icon"
                                                     [ngClass]="{'active':tournament.status=='Waiting Players to Join',
                                  'finished':tournament.status=='Finished', 'inprogress':tournament.status=='In Progress',
                                  'closed':tournament.status=='Registration Closed'}"></div>

                                                <p *ngIf="tournament.status=='Waiting Players to Join'">التسجيل
                                                    مفتوح</p>
                                                <p *ngIf="tournament.status=='inprogress'">جارية الان</p>
                                                <p *ngIf="tournament.status=='Finished'">انتهت</p>
                                                <p *ngIf="tournament.status=='Registration Closed'">التسجيل مغلق</p>
                                            </div>

                                        </div>

                                    </div>
                                </a>

                            </div>
                            <div class="col-sm-6 hidden-xs">

                                <div class="info">
                                    <h1>{{tournament.name}}</h1>
                                    <div class="flex_block row">
                                            <span class="row">
                                                <p>
                                                 <i class="icon-calendar"></i>
                                                 {{globalService.Date(tournament.start_at)}}

                                                      {{globalService.Time(tournament.start_at)}},
                                                 {{tournament.time_zone}}
                                                </p>
                                            </span>
                                    </div>

                                    <div class="status"
                                         style="display: flex; justify-content: flex-start; align-items: center;">

                                        <div class="icon"
                                             [ngClass]="{'active':tournament.status=='Waiting Players to Join',
                                  'finished':tournament.status=='Finished', 'inprogress':tournament.status=='In Progress',
                                  'closed':tournament.status=='Registration Closed'}"></div>

                                        <p *ngIf="tournament.status=='Waiting Players to Join'">التسجيل مفتوح</p>
                                        <p *ngIf="tournament.status=='inprogress'">جارية الان</p>
                                        <p *ngIf="tournament.status=='Finished'">انتهت</p>
                                        <p *ngIf="tournament.status=='Registration Closed'">التسجيل مغلق</p>

                                    </div>

                                    <a href="https://www.gbarena.com/tournaments/{{tournament.code}}" target="_blank"
                                       class="go_button white sm">ابداء اللعب الان
                                        <i class="icon-gamepad"></i>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="no-data " *ngIf="(eventService.eventTournaments|async)?.data?.length==0">
                        <p>
                            لم يتم إضافة بطولات
                            بعد
                        </p>
                    </div>
                </div>


            </mat-tab>

            <mat-tab label="tab2" id="test">
                <ng-template mat-tab-label>
                    <!--<i class="icon-trophy"></i>-->
                    الترتيب
                </ng-template>

                <div class="container">
                    <select style="color:black" (change)="selectTournament($event)">
                        <option style="color:black">Choose Tournament</option>
                        <option style="color:black" *ngFor=" let tournament of tournaments" value="{{tournament.value}}">{{tournament.name}}</option>
                    </select>
                    <div *ngIf="leaderboards.length == 0" class="no-data">
                        لم يتم الإعلان عن الترتيب بعد
                    </div>
                    <div *ngIf="leaderboards.length > 0">
                        <ul>
                            <li style="color:white" *ngFor="let participant of leaderboards"> {{ participant.original.participant_name}} </li>
                        </ul>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="tab2" id="test">
                <ng-template mat-tab-label>
                    <!--<i class="icon-trophy"></i>-->
                    المتأهلون
                </ng-template>

                <div class="container">
                    <div *ngFor="let tournament of (eventService.eventTournaments|async)?.data |dateSortTournament:true">
                        <h1 style="font-size:14px; font-family: 'proxima-nova-bold-webfont', 'Frutiger LT Arabic 65 Bold'">{{tournament.name}}</h1>
                        <div *ngIf="tournament.winners?.length>0 ;else noWinners">
                            <div class="winners-container">
                                <a class="winner-block" *ngFor="let winner of tournament.winners" href="https://gbarena.com/gamer/{{winner.participant_name}}" target="_blank">
                                    <img src="{{winner.participant_avatar}}" alt="">
                                    <h1>{{winner.participant_name}}</h1>
                                </a>
                            </div>
                        </div>

                        <ng-template #noWinners>
                            <div class="no-data">
                                 لم يتم الإعلان عن المتأهلون في هذة البطولة بعد
                            </div>
                        </ng-template>
                    </div>
                </div>
            </mat-tab>

        </mat-tab-group>


    </ng-container>
    <ng-template #loading>
    </ng-template>
</div>
